
import React from "react";
import Header from "./components/Header";
import Hero from "./components/Hero";
import FeatureGrid from "./components/FeatureGrid";
import WhyChoose from "./components/WhyChoose";
import Testimonials from "./components/Testimonials";
import Footer from "./components/Footer";
import "./styles.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'animate.css';
import FloatingCall from "./components/FloatingCall";
import USPSection from "./components/USPSection/USPSection";
import Plans from "./components/PlanCard/Plans";
import ContactUs from "./components/ContactUs";

function Home() {
  return (
    <div className="app-wrapper">
      <Hero />
      <FeatureGrid />
      <WhyChoose />
      <Plans />
      <USPSection />
      <ContactUs />
      <Testimonials />

    </div>
  );
}

export default Home;
